import routerOptions0 from "/usr/src/app/node_modules/.pnpm/nuxt@3.19.0_@emnapi+core@1.11.3_@emnapi+runtime@1.11.3_@parcel+watcher@2.5.1_@types+nod_8011865266390b0e4bb9267123272e5c/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/usr/src/app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}